  (function () {
    var MOBILE = window.matchMedia('(max-width: 768px)');

    // Runs once per render, but binds EVERY switcher on the page (toolbar +
    // footer) — the per-root data flag makes the second pass a no-op for
    // instances already wired up, and picks up any that rendered later in
    // the document than the first script did.
    document.querySelectorAll('[data-region-switcher]').forEach(function (root) {
      if (root.dataset.regionSwitcherInit) return;
      root.dataset.regionSwitcherInit = 'true';

      var toggle = root.querySelector('[data-region-switcher-toggle]');
      var sheet = root.querySelector('[data-region-switcher-sheet]');
      var panel = root.querySelector('[data-region-switcher-panel]');
      var grab = root.querySelector('[data-region-switcher-grab]');
      if (!toggle || !sheet || !panel) return;

      // The mobile sheet is position:fixed, but a transformed ancestor
      // becomes the containing block for fixed descendants — and the
      // toolbar pins .toolbar-v2__selecty with translateY(-50%) on mobile,
      // which would trap the "fixed" sheet inside an 88px pill wrapper.
      // So while open on mobile the sheet is portalled to <body> (and put
      // back on close, so the desktop absolute anchoring keeps working).
      var sheetHome = sheet.parentElement;

      function setOpen(open) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && MOBILE.matches) {
          document.body.appendChild(sheet);
        } else if (sheet.parentElement !== sheetHome) {
          sheetHome.appendChild(sheet);
        }
        sheet.hidden = !open;
        panel.style.transform = '';
        // The mobile sheet overlays the page — freeze the page scroll
        // behind it while it's up. Desktop dropdown never locks anything.
        document.documentElement.style.overflow = (open && MOBILE.matches) ? 'hidden' : '';
      }

      toggle.addEventListener('click', function () {
        setOpen(sheet.hidden);
      });

      // Mobile: tapping the dimmed backdrop (the sheet wrapper itself, not
      // the panel) closes. Desktop clicks inside the dropdown never hit the
      // wrapper directly, so this is mobile-only by construction.
      sheet.addEventListener('click', function (event) {
        if (event.target === sheet) setOpen(false);
      });

      document.addEventListener('click', function (event) {
        // sheet.contains too: while portalled to <body> it's outside root.
        if (!sheet.hidden && !root.contains(event.target) && !sheet.contains(event.target)) setOpen(false);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !sheet.hidden) {
          setOpen(false);
          toggle.focus();
        }
      });

      // ── Drag-to-dismiss (mobile sheet) ────────────────────────────────
      // Pointer-based so it covers touch, pen and mouse. Drag starts on the
      // grab area (handle + SELECT YOUR STORE header) — not the option list,
      // which needs its taps and any future scrolling to itself. Downward
      // drag follows the finger 1:1; upward drag rubber-bands (a third of
      // the distance, capped) and snaps back — the sheet is already fully
      // open, up has nowhere to go. Release closes when the sheet is more
      // than a third of the way down OR moving fast (a flick), else snaps
      // back to open.
      if (grab && window.PointerEvent) {
        var dragging = false;
        var startY = 0;
        var lastY = 0;
        var lastT = 0;
        var velocity = 0;

        grab.addEventListener('pointerdown', function (event) {
          if (!MOBILE.matches || sheet.hidden) return;
          dragging = true;
          startY = lastY = event.clientY;
          lastT = event.timeStamp;
          velocity = 0;
          panel.style.transition = 'none';
          grab.setPointerCapture(event.pointerId);
        });

        grab.addEventListener('pointermove', function (event) {
          if (!dragging) return;
          var dy = event.clientY - startY;
          var dt = event.timeStamp - lastT;
          if (dt > 0) velocity = (event.clientY - lastY) / dt;
          lastY = event.clientY;
          lastT = event.timeStamp;
          // Down follows the finger 1:1; up is elastic (a third of the
          // distance, uncapped) — the sheet visibly lifts, and release
          // settles it back to the resting position below.
          var shift = dy >= 0 ? dy : dy / 3;
          panel.style.transform = 'translateY(' + shift + 'px)';
        });

        function endDrag(event) {
          if (!dragging) return;
          dragging = false;
          var dy = event.clientY - startY;
          var shouldClose = dy > panel.offsetHeight / 3 || (dy > 20 && velocity > 0.5);
          if (shouldClose) {
            // Let the sheet finish sliding out from wherever the finger
            // left it, then actually close.
            sheet.classList.add('is-closing');
            panel.style.transition = 'transform .2s ease-in';
            panel.style.transform = 'translateY(100%)';
            var done = function () {
              panel.style.transition = '';
              sheet.classList.remove('is-closing');
              panel.removeEventListener('transitionend', done);
              setOpen(false);
            };
            panel.addEventListener('transitionend', done);
            // Fallback in case transitionend is swallowed.
            setTimeout(done, 300);
          } else {
            panel.style.transition = 'transform .2s ease-out';
            panel.style.transform = 'translateY(0)';
            setTimeout(function () {
              panel.style.transition = '';
              panel.style.transform = '';
            }, 220);
          }
        }

        grab.addEventListener('pointerup', endDrag);
        grab.addEventListener('pointercancel', endDrag);
      }

      // Leaving the mobile breakpoint with the sheet open would strand a
      // full-screen fixed overlay styled for phones — just close it.
      MOBILE.addEventListener('change', function () {
        if (!sheet.hidden) setOpen(false);
      });
    });
  })();
